module.exports = __webpack_public_path__ + "img/Successfulpurchase-bro.02990393.png";